/* eslint-disable max-lines */
// Packages Imports
import moment from 'moment';

// Project Imports
import SocketEvent from 'core/constants/SocketEvent';
import openNotificationWithIcon from 'core/utils/notification';
import useLogger from 'core/utils/useLogger';
// import setNotificatonApi from 'core/utils/setNotificationApi';

function updateOrAddNotificationMsg(notificationArray, newNotificationMsg) {
  // Find the index of the object that has the matching key and value
  const index = notificationArray?.findIndex(
    (obj) => obj?.uniqueId === newNotificationMsg?.uniqueId
  );

  if (index !== -1) {
    // If newNotificationMsg is found in notificationArray, update the process with new newNotificationMsg
    // eslint-disable-next-line no-param-reassign
    notificationArray[index] = newNotificationMsg;
  } else {
    // If newNotificationMsg is not found, add the newNotificationMsg to the notificationArray
    notificationArray?.push(newNotificationMsg);
  }

  return notificationArray;
}

const shouldTriggerApi = (notificationLocalstorage, updatedNewMessage) => {
  const finalStatuses = ['success', 'failed'];

  // If it's NOT "Input Data Upload", always trigger. need to check if other event also getting in-progress, success & failed status then no need to check eventName
  // const msgEventName = updatedNewMessage?.eventName?.toLowerCase();
  // if (msgEventName !== 'input data upload') {
  //   return true;
  // }

  const existingNotification = notificationLocalstorage?.find(
    (obj) => obj?.uniqueId === updatedNewMessage?.uniqueId
  );

  const oldStatus = existingNotification?.status?.toLowerCase();
  const newStatus = updatedNewMessage?.status?.toLowerCase();

  const isOldFinal = finalStatuses.includes(oldStatus);
  const isNewFinal = finalStatuses.includes(newStatus);

  return oldStatus !== newStatus && (isOldFinal || isNewFinal);
};

const updateNotifications = (
  newMessage,
  userId,
  id,
  setNotificationMessages,
  socketInstance,
  toggleSocketNotificationsApi
  // toggleSocketNotifications
) => {
  const updatedNewMessage = { ...newMessage };
  if (updatedNewMessage.timestamp) {
    const adjustedTimestamp = moment(updatedNewMessage.timestamp)
      .add(5, 'hours')
      .add(30, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss');
    updatedNewMessage.timestamp = adjustedTimestamp;
  }
  const notificationList = localStorage.getItem('notifications');
  const notificationLocalstorage =
    JSON.parse(notificationList)?.length > 0
      ? JSON.parse(notificationList)
      : [];
  const shouldTrigger = shouldTriggerApi(
    notificationLocalstorage,
    updatedNewMessage
  );
  const updatedMessages = updateOrAddNotificationMsg(
    notificationLocalstorage,
    updatedNewMessage
  );
  if (updatedMessages?.length > notificationLocalstorage?.length) {
    // show notification if new message added
    openNotificationWithIcon(
      updatedNewMessage.status,
      updatedNewMessage?.title,
      updatedNewMessage?.message
    );
  }

  if (userId === id) {
    localStorage.setItem('notifications', JSON.stringify(updatedMessages));
    setNotificationMessages(updatedMessages);

    if (shouldTrigger) {
      toggleSocketNotificationsApi(updatedNewMessage?.title);
    }
  }
};

const fetchNotificatons = async (
  setNotificationMessages,
  userDetails,
  socketInstance,
  toggleSocketNotificationsApi
): Promise<void> => {
  try {
    socketInstance.on(SocketEvent.INPUT_SYNC_EVENT_NAME, (data) => {
      console.log('fetchNotificatons input data >>', data);
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        sourceId: data?.source_id,
        read: false,
        extraKeys: data?.extra_keys,
        sourceName: data?.source_name,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.MASTER_SYNC_EVENT_NAME, (data) => {
      // console.log('fetchNotificatons master data >>', data);
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        sourceId: data?.source_id,
        read: false,
        extraKeys: data?.extra_keys,
        sourceName: data?.source_name,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.INITIATE_UNIFICATION_EVENT_NAME, (data) => {
      // console.log('fetchNotificatons unification data >>', data);
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        sourceId: data?.source_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.START_CALCULATION_EVENT_NAME, (data) => {
      // console.log('fetchNotificatons calculation data >>', data);
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.NUDGE_EVENT_NAME, (data) => {
      // console.log('fetchNotificatons nudge data >>', data);
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.TASK_CREATION_PROGRESS, (data) => {
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.TASK_APPROVAL, (data) => {
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.TASK_REMINDER, (data) => {
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
    socketInstance.on(SocketEvent.TASK_ESCALATION, (data) => {
      const newMessage = {
        title: data?.event_name,
        eventName: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        socketInstance,
        toggleSocketNotificationsApi
      );
    });
  } catch (error) {
    const logger = useLogger();
    logger('Socket Error', error);
  }
};

export default fetchNotificatons;
